import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ui_icon = _resolveComponent("ui-icon")!
  const _component_ui_input = _resolveComponent("ui-input")!
  const _component_ui_group_option = _resolveComponent("ui-group-option")!
  const _component_ui_button = _resolveComponent("ui-button")!
  const _component_ui_editor_toolbox = _resolveComponent("ui-editor-toolbox")!

  return (_openBlock(), _createBlock(_component_ui_editor_toolbox, {
    toolbox: $setup.showToolbox,
    "onUpdate:toolbox": _cache[6] || (_cache[6] = ($event: any) => (($setup.showToolbox) = $event)),
    disabledAnimation: ""
  }, {
    default: _withCtx(() => [
      (!$setup.downMode)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createVNode($setup["CoordTypeCom"], {
              type: $setup.selectType,
              "onUpdate:type": _cache[3] || (_cache[3] = ($event: any) => (($setup.selectType) = $event)),
              modelValue: $setup.customMap.coord,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.customMap.coord) = $event)),
              "dis-show": 
          $setup.unSetScene
            ? [$setup.CoordinateType.GIS, $setup.CoordinateType.PRO].map(i => i.toString())
            : []
        
            }, {
              append: _withCtx(({ type, disabled }) => [
                (!disabled && Number(type) === $setup.CoordinateType.GIS)
                  ? (_openBlock(), _createBlock(_component_ui_input, {
                      key: 0,
                      readonly: "",
                      class: "format-input",
                      style: {"margin-top":"10px"},
                      placeholder: _ctx.$t('sys.inputPlc'),
                      type: "text",
                      modelValue: 
              $setup.outType === $setup.CoordOutType.DMS
                ? _ctx.$t('coord.edit.dms')
                : _ctx.$t('coord.edit.num')
            ,
                      width: "100%"
                    }, {
                      icon: _withCtx(() => [
                        _createVNode(_component_ui_icon, {
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (
                  $setup.outType =
                    $setup.outType === $setup.CoordOutType.DMS
                      ? $setup.CoordOutType.LN
                      : $setup.CoordOutType.DMS
                )),
                          type: "change1",
                          ctrl: ""
                        })
                      ]),
                      _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["placeholder", "modelValue"]))
                  : _createCommentVNode("v-if", true)
              ]),
              first: _withCtx(() => [
                _createVNode(_component_ui_group_option, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_ui_input, {
                      type: "radio",
                      label: $setup.getCoordLabel($setup.LocalCoord.LOCAL),
                      modelValue: $setup.LocalCoord.LOCAL === $setup.selectType,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ($setup.selectType = $setup.LocalCoord.LOCAL))
                    }, null, 8 /* PROPS */, ["label", "modelValue"]),
                    _createCommentVNode(" <Info v-if=\"unSetScene\" type=\"info\" :msg=\"$t('coord.unCtrlUse')\">\n            <a\n              class=\"info-link\"\n              :href=\"`https://www.4dkankan.com/www/mddoc/manual/index.html#/product/laser/${\n                lang === langNameEum.zh ? 'zh-cn' : 'en-us'\n              }/whycontrolpoint`\"\n              target=\"_blank\"\n              >{{ $t(\"sys.operTip\") }}</a\n            >\n          </Info> ")
                  ]),
                  _: 1 /* STABLE */
                })
              ]),
              last: _withCtx(() => [
                _createVNode(_component_ui_group_option, {
                  class: _normalizeClass({ disabled: $setup.unSetScene })
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ui_input, {
                      type: "radio",
                      label: $setup.getCoordLabel($setup.map),
                      modelValue: $setup.map === $setup.selectType,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ($setup.selectType = $setup.map))
                    }, null, 8 /* PROPS */, ["label", "modelValue"])
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["class"])
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["type", "modelValue", "dis-show"]),
            ($setup.isLogin)
              ? (_openBlock(), _createBlock(_component_ui_button, {
                  key: 0,
                  class: "start-measure",
                  type: "primary",
                  onClick: _cache[5] || (_cache[5] = ($event: any) => ($setup.useEdit())),
                  style: {"margin-top":"20px"}
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('coord.download')), 1 /* TEXT */)
                  ]),
                  _: 1 /* STABLE */
                }))
              : _createCommentVNode("v-if", true)
          ], 64 /* STABLE_FRAGMENT */))
        : (_openBlock(), _createBlock($setup["download"], { key: 1 }))
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["toolbox"]))
}